import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../../assets/scss/modules/kampany.module.scss';
import twitter from "../../assets/media/images/Twitter.png";
import tiktok from "../../assets/media/images/Tiktok.png";
import instagram from "../../assets/media/images/Instagram.png";
import facebook from "../../assets/media/images/Facebook.png";
import jogasz from "../../assets/media/images/jogasz.png";
import kepviselo from "../../assets/media/images/kepviselo.png";
import csalad from "../../assets/media/images/csalad.png";
import asset1 from "../../assets/media/images/asset1.png";
import asset2 from "../../assets/media/images/asset2.png";
import asset3 from "../../assets/media/images/asset3.png";
import asset4 from "../../assets/media/images/asset4.png";
import asset5 from "../../assets/media/images/Titles/meltoIdoskort.png";
import asset6 from "../../assets/media/images/asset6.png";
import back_btn from "../../assets/media/newicons/back.png";
import back_btn_inverz from "../../assets/media/newicons/back_darkMode.png";
import back_btn_black from "../../assets/media/newicons/back-black.png";
import forward_btn_black from "../../assets/media/newicons/nextBlue.png";
import forward_btn from "../../assets/media/newicons/forward.png";
import forward_btn_inverz from "../../assets/media/newicons/next_darkMode.png";
import erikfoto from "../../assets/media/images/Erik-foto.png";
import konczer_facebook from "../../assets/media/images/konczer-facebook.png";
import Footer from "../Footer/Footer";
import FooterResponziv from "../Footer/FooterResponziv";
import NavbarComponent from "../../NavbarComponent";




import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class BackComponentRespo extends Component {

  render() {
		let darkmode= false;
		if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
	    let darkmode= true;
		}
    return (
				<div className={this.props.navbarPaddingTop ? "landing-nav-container d-flex d-lg-none" : "landing-nav-container-scroll d-flex d-lg-none"}>
					<MDBRow className="m-0" style={{width: "100%", height: "24px"}}>
						<MDBCol middle size="1" className="text-right pl-0 pr-3">
							<MDBRow end className="m-0 p-0">
								<Link flat to="/"><img className="back-btn" src={back_btn_black}></img></Link>
							</MDBRow>
						</MDBCol>
						<MDBCol middle size="5" className="text-left p-0">
							<MDBRow start className="m-0">
								<Link flat to="/"><span className="back-text text-capitalize">Programok</span></Link>
							</MDBRow>
						</MDBCol>
						{!this.props.navbarPaddingTop ?
						<>
						<MDBCol middle size="5" className="text-right p-0">
						<MDBRow end className="m-0">
							<Link to={"/" + this.props.text}><span className="back-text text-capitalize">Következő</span></Link>
						</MDBRow>
						</MDBCol>
						<MDBCol middle size="1" className="text-left pr-0 pl-3">
						<MDBRow start className="m-0">
							<Link to={"/" + this.props.text}><img className="forward-btn" src={forward_btn_black}></img></Link>
						</MDBRow>
						</MDBCol>
						</>:false}
					</MDBRow>
				</div>
    );
  }
}
export default  BackComponentRespo;
